import theme from "../../theme";

export const style = {
  SECTION: {
    background: theme.foregroundColor,
  },
  SECTION_INNER: {
    margin: "0 auto",
    mobile: {
      desktop: {
        padding: 100,
      },
      smartphone: {
        padding: 20,
      },
    },
  },
  HEADLINE: {
    textAlign: "center",
    fontSize: "28pt",
    fontFamily: theme.fontFamily,
    fontWeight: 200,
    //    fontWeight: "bold" as "bold",
    paddingBottom: 100,
  },
  ITEM_HEADLINE: {
    textAlign: "center",
    fontSize: "14pt",
    fontFamily: theme.fontFamily,
    fontWeight: "bold" as "bold",
  },
  TEXT: {
    textAlign: "center",
    fontFamily: theme.fontFamily,
    marginTop: 20,
    lineHeight: "18pt",
  },
  ICON: {
    display: "inline-block",
    borderRadius: "100%",
    backgroundColor: "transparent",
    padding: 10,
    color: theme.backgroundColor,
    border: `1px solid ${theme.backgroundColor}`,
    marginBottom: 20,
    textAlign: "center",
  },
};
